<template>
  <v-card flat class="pa-6">
    <v-card-title class="text-h6 primary--text mb-6">
      {{ $t("game_text_contents") }}
    </v-card-title>

    <v-card-text v-if="gameConfig && gameConfig.texts">
      <v-row dense>
        <v-col v-for="(field, key) in textsSchema" :key="key" cols="12" md="6">
          <component
            :is="getComponentForField(field.type)"
            v-model="gameConfig.texts[key]"
            :label="field.label || key"
            outlined
            dense
            @input="sync"
          >
            <template v-if="field.type === 'array'">
              <draggable v-model="gameConfig.texts[key]" handle=".handle">
                <v-row
                  v-for="(item, index) in gameConfig.texts[key]"
                  :key="index"
                  dense
                  class="mb-2 align-center"
                >
                  <v-col cols="auto"
                    ><v-icon class="handle">mdi-drag</v-icon></v-col
                  >
                  <v-col>
                    <v-text-field
                      v-model="gameConfig.texts[key][index]"
                      dense
                      outlined
                      hide-details
                    />
                  </v-col>
                  <v-col cols="auto">
                    <v-btn
                      icon
                      small
                      color="error"
                      @click="
                        gameConfig.texts[key].splice(index, 1);
                        sync();
                      "
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </draggable>
              <v-btn
                small
                color="primary"
                outlined
                class="mt-2"
                @click="
                  gameConfig.texts[key].push('');
                  sync();
                "
              >
                <v-icon left small>mdi-plus</v-icon>
                {{ $t("add_item") }}
              </v-btn>
            </template>
          </component>
        </v-col>

        <!-- اگر هیچ فیلدی نبود -->
        <v-col v-if="!Object.keys(textsSchema).length" cols="12">
          <v-alert type="info" text prominent>
            متنی برای این بازی تعریف نشده است.
          </v-alert>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import draggable from "vuedraggable";

export default {
  name: "TabTexts",
  components: { draggable },
  props: {
    value: { type: Object, required: true },
    schema: { type: Object, required: true },
  },
  computed: {
    gameConfig: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    gameType() {
      return this.gameConfig?.type || null;
    },
    textsSchema() {
      return this.schema?.textsConfig || {};
    },
  },
  methods: {
    sync() {
      this.$emit("input", { ...this.gameConfig });
    },
    getComponentForField(type) {
      if (type === "array") return "div";
      if (type === "html") return "v-textarea";
      return "v-text-field";
    },
  },
};
</script>

<style scoped>
.handle {
  cursor: move;
  color: #888;
}
</style>
